export var version = '3.7.0';
//# sourceMappingURL=version.js.map